import * as React from 'react';
import { cn } from '../utils/cn';

export interface BadgeProps {
  /** Badge count (number or custom element) */
  count?: React.ReactNode;
  /** Show as small dot instead of count */
  dot?: boolean;
  /** Max count before showing "+" */
  overflowCount?: number;
  /** Additional class names */
  className?: string;
  /** Badge style */
  style?: React.CSSProperties;
  /** Wrapped content */
  children?: React.ReactNode;
}

export function Badge({
  count,
  dot = false,
  overflowCount = 99,
  className,
  style,
  children,
}: BadgeProps) {
  const showBadge = count !== undefined || dot;

  let displayCount: React.ReactNode = count;
  if (typeof count === 'number' && count > overflowCount) {
    displayCount = `${overflowCount}+`;
  }

  return (
    <div className={cn('relative inline-flex', className)}>
      {children}
      {showBadge && (
        <span
          className={cn(
            'absolute z-10',
            dot
              ? 'top-0 right-0 h-2 w-2 rounded-full bg-destructive'
              : typeof count === 'number'
                ? 'top-0 right-0 -translate-y-1/2 translate-x-1/2 flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-destructive text-white text-[10px] font-body font-bold'
                : 'top-0 right-0 -translate-y-1/2 translate-x-1/2'
          )}
          style={style}
        >
          {!dot && displayCount}
        </span>
      )}
    </div>
  );
}
